// Components
import { Table } from '../../components';

// Static Images
import BackIcon from '../../static/images/left-arrow.png';
import DownloadIcon from '../../static/images/download.png';

// Actions
import {
    fetchBulkRefundFileTableDataByIdRequest,
    downloadBulkRefundFileByIdRequest,
} from './redux/bulkRefund.actions';

// Libraries
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const TableHead = ({
    requestId,
    fileName,
    totalRecordCount,
    totTxnAmt,
    downloadRequest,
}) => {
    const history = useHistory();

    const onBack = () => {
        history.push('/bulk-refund');
    };

    const handleDownload = () => {
        downloadRequest(requestId);
    };

    return (
        <div className="bulkRefund-table-header-wrapper">
            <div className="bulkRefund-table-header-information-container">
                <div className="bulkRefund-table-header-option">
                    <button
                        type="submit"
                        className="back-icon"
                        onClick={onBack}
                    >
                        <img src={BackIcon} alt="Back" />
                    </button>
                </div>
                <div className="bulkRefund-table-header-option">
                    <p className="title">Request ID</p>
                    <p className="title-value">{requestId}</p>
                </div>
                <div className="bulkRefund-table-header-option">
                    <p className="title">File Name</p>
                    <p className="title-value">{fileName}</p>
                </div>
                <div className="bulkRefund-table-header-option">
                    <p className="title">Total Count</p>
                    <p className="title-value">{totalRecordCount}</p>
                </div>
                <div className="bulkRefund-table-header-option">
                    <p className="title">Total Amount</p>
                    <p className="title-value">{totTxnAmt}</p>
                </div>
            </div>
            <div
                className="bulkRefund-table-header-download-wrapper"
                onClick={handleDownload}
            >
                <img
                    src={DownloadIcon}
                    alt="Download"
                    className="download-icon"
                />
                <div className="action-text">
                    <p>Download</p>
                </div>
            </div>
        </div>
    );
};

const BulkRefundFileView = ({ actions, bulkRefundData }) => {
    const location = useLocation();
    const { requestId, fileName, totalRecordCount, totTxnAmt } = location.state;
    const {
        selectedBulkUploadFile,
        selectedBulkUploadFileTableData,
        pagination,
        isLoading,
    } = bulkRefundData;

    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isResetPage, setIsResetPage] = useState(false);

    const fetchData = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,
            const data = {
                pageSize,
                pageNo: pageIndex,
                requestId,
            };
            actions.fetchBulkRefundFileTableDataByIdRequest({
                ...data,
                requestId,
            });
            setPageSize(pageSize);
        },
        [actions, requestId]
    );

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    const columnsRecent = useMemo(
        () => [
            {
                header: 'Refund Transaction ID',
                accessor: 'merchantRefundTxnId',
            },
            { header: 'Status', accessor: 'status' },
            { header: 'Amount', accessor: 'refundAmount' },
            { header: 'Message', accessor: 'statusMessage' },
        ],
        []
    );

    return (
        <>
            <Table
                columns={columnsRecent}
                data={selectedBulkUploadFileTableData}
                tableHead={
                    <TableHead
                        requestId={requestId}
                        fileName={fileName}
                        totalRecordCount={totalRecordCount}
                        totTxnAmt={totTxnAmt}
                        downloadRequest={requestId =>
                            actions.downloadBulkRefundFileByIdRequest({
                                requestId,
                                fileTypeEnum: 'PROCESSED',
                            })
                        }
                    />
                }
                error={null}
                loading={isLoading}
                fetchData={fetchData}
                tableFilters={null}
                isPaginationEnable
                numberOfRecord={pagination.totalNumberOfRecords}
                paginationLabel="Rows per page"
                pageSizeOptions={pageSizeOptions}
                pagePerView={3}
                pageCount={pageCount}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
            />
        </>
    );
};

TableHead.propTypes = {
    requestId: PropTypes.string,
    fileName: PropTypes.string,
    totalRecordCount: PropTypes.string,
    totTxnAmt: PropTypes.string,
    downloadRequest: PropTypes.func,
};

BulkRefundFileView.propTypes = {
    actions: PropTypes.object,
    bulkRefundData: PropTypes.object,
};

const mapStateToProps = ({
    auth,
    bulkRefundData,
    loader,
    staticData,
    actions,
}) => ({
    auth,
    bulkRefundData,
    loader,
    staticData,
    actions,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchBulkRefundFileTableDataByIdRequest,
            downloadBulkRefundFileByIdRequest,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkRefundFileView);
